/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UploadFile } from './UploadFile'
export type ComponentsCardComponent = {
  id?: number
  title?: string
  content?: string
  link?: {
    id?: number
    title?: string
    url?: string
  }
  visual?: UploadFile
  style?: ComponentsCardComponent.style
  centered?: boolean
}
export namespace ComponentsCardComponent {
  export enum style {
    PRIMARY = 'Primary',
    SECONDARY = 'Secondary',
    TERTIARY = 'Tertiary',
  }
}
